import React, { FC } from 'react';

import ProgressRing from '@adsk/alloy-react-progress-ring';

import FlexCentered from './FlexCentered';

const FullPageProgressRing: FC = () => (
  <FlexCentered width="100%" height="100%" position="fixed">
    <ProgressRing size={ProgressRing.SIZES.LARGE} />
  </FlexCentered>
);

export default FullPageProgressRing;
